import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useGoBack from "hooks/useGoBack";
import useUserStore from "@store/useUserStore";
import { getMySchedule } from "api/user";
import NoData from "components/common/NoData";
import dayjs from "dayjs";
import { getKstDday } from "utils/util";
import "assets/scss/pages/mybuccl.scss";

const getDday = getKstDday;

const LessonHistory = () => {
    const navigate = useNavigate();
    const goBack = useGoBack();
    const userInfo = useUserStore((state) => state.userInfo);
    const [upcomingItems, setUpcomingItems] = useState([]);
    const [pastItems, setPastItems] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (userInfo !== null) {
            setIsLoading(true);
            getMySchedule()
                .then((res) => {
                    const all = [...res.lessons, ...res.practices];
                    const today = dayjs().startOf("day");

                    const upcoming = all
                        .filter((item) => {
                            const date = item?.schedule_info?.date || item?.date;
                            return dayjs(date).isSame(today, "day") || dayjs(date).isAfter(today);
                        })
                        .sort((a, b) => new Date(a?.schedule_info?.date || a?.date) - new Date(b?.schedule_info?.date || b?.date));

                    const past = all
                        .filter((item) => {
                            const date = item?.schedule_info?.date || item?.date;
                            return dayjs(date).isBefore(today);
                        })
                        .sort((a, b) => new Date(b?.schedule_info?.date || b?.date) - new Date(a?.schedule_info?.date || a?.date));

                    setUpcomingItems(upcoming);
                    setPastItems(past);
                })
                .catch((err) => console.error("강습 내역 로딩 오류:", err))
                .finally(() => setIsLoading(false));
        }
    }, [userInfo]);

    const renderCard = (info, isPast) => {
        const scheduleInfo = info.schedule_info || info;
        const date = info.date || scheduleInfo.date;
        const d = dayjs(date);
        const instructor = scheduleInfo.instructor_name || "";
        const location = scheduleInfo.location_name || "";
        const startTime = scheduleInfo.start_time?.slice(0, 5);
        const endTime = scheduleInfo.end_time?.slice(0, 5);
        const detail = [instructor, location, startTime && endTime ? `${startTime}~${endTime}` : ""].filter(Boolean).join(" | ");
        const title = scheduleInfo.schedule_title || scheduleInfo.lesson_product_display_name;

        return (
            <div
                key={`${info.id}-${date}`}
                className={`reservation-card ${isPast ? "reservation-card--past" : ""}`}
                onClick={() => {
                    const type = info.schedule_info ? "class" : "practice";
                    navigate(`/reservation/${type}/${info.schedule || info.practice_schedule}`);
                }}
            >
                <div className={`reservation-date-block ${isPast ? "date-block--past" : ""}`}>
                    <span className="reservation-date-month">{d.format("M")}월</span>
                    <span className="reservation-date-day">{d.format("D")}</span>
                </div>
                <div className="reservation-card-content">
                    <p className="reservation-card-title">{title}</p>
                    <p className="reservation-card-detail">{detail}</p>
                </div>
                <span className={`reservation-card-dday ${isPast ? "dday--past" : ""}`}>
                    {isPast ? "완료" : getDday(date)}
                </span>
            </div>
        );
    };

    return (
        <div className="community-page community-list">
            <div className="community-header detail-header">
                <div className="header-content">
                    <button className="back-button" onClick={() => goBack()}>
                        <svg viewBox="0 0 24 24" fill="none" width="24" height="24">
                            <path d="M15 19l-7-7 7-7" stroke="#17191a" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </button>
                    <h1 className="header-title">수강 내역</h1>
                </div>
            </div>
            <div className="reservation-tab">
                {isLoading ? (
                    <div style={{ textAlign: "center", padding: "40px 0", color: "#999" }}>불러오는 중...</div>
                ) : upcomingItems.length === 0 && pastItems.length === 0 ? (
                    <NoData title="🗓️" desc="아직 예약한 수강이 없어요." />
                ) : (
                    <>
                        {upcomingItems.length > 0 && (
                            <div className="reservation-section">
                                <h3 className="reservation-section-title">📅 다가오는 수강</h3>
                                <div className="reservation-list">
                                    {upcomingItems.map((item, idx) => renderCard(item, false))}
                                </div>
                            </div>
                        )}
                        {pastItems.length > 0 && (
                            <div className="reservation-section">
                                <h3 className="reservation-section-title">📋 지난 수강</h3>
                                <div className="reservation-list">
                                    {pastItems.map((item, idx) => renderCard(item, true))}
                                </div>
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

export default LessonHistory;
